<template>
    <div class="container-fluid">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
                  <b>Customer Company : หน่วยงานบริษัทลูกค้า</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
              <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:250px;">New</button>
              <!-- <div class="col float-end "> <input class="btn btn-primary" value="New" @click="newRecord()"></div> -->
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myClinicTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th style="width: 50px;">แก้ไข</th>
                    <th style="width: 120px;">รหัส</th>
                    <th style="width: 300px;">ชื่อหน่วยงาน/บริษัท</th>
                    <th style="width: 100px;">ใช้ราคาขายที่</th>
                    <th >ที่อยู่</th>
                    <th style="width: 150px;">โทรศัพท์</th>
                    <th style="width: 50px;">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.reqclinicid" v-bind:data-id="item.reqclinicid" @click="tableChanged(item)">
                    <td class="py-1">
                      <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                    </td>
                    <td class="text-start py-1">{{ item.ReqClinicCode }}</td>
                    <td class="text-start py-1">{{ item.ReqClinicName }}</td>
                    <td class="text-center py-1">{{ item.UnitPriceNo }}</td>
                    <td class="text-start py-1">{{ item.Addr1 }} {{ item.Amphor }} {{ item.Tambon }} {{ item.Province }}</td>
                    <td class="text-start py-1">{{ item.Tel1 }} {{ item.Tel2 }}</td>
                    <td class="py-1" >
                      <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal Form -->
        <div id="exampleModal" class="modal" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">ลูกค้าหน่วยงานบริษัท</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form id="fmClinicReq" @submit.prevent="" >
                    <input type="text" hidden class="form-control" id="MemberName" placeholder="" name="MemberName" v-model="globalCorpInfo.MemberName" >
                    <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                    <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                    <input type="text" hidden class="form-control" placeholder="" name="id" v-model="curRecord.ReqClinicID" >
                    <div class="row">
                      <div class="col-8">
                        <div class="row mb-2">
                            <div class="col-4 text-start">
                                <label for="code" class="mr-sm-2">รหัส:</label>
                                <input type="text" class="form-control" id="code" placeholder="รหัสบริษัท*" ref="ReqClinicCode" name="code" autocomplete="off" v-model="curRecord.ReqClinicCode" required>
                            </div>
                            <div class="col-8 text-start">
                                <label for="name" class="mr-sm-2 ">ชื่อหน่วยงาน:</label>
                                <input type="text" class="form-control" id="name"  placeholder="ชื่อหน่วยงานบริษัท*" ref="ReqClinicName" name="name" autocomplete="off" v-model="curRecord.ReqClinicName" required style="font-weight:bold;">
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col text-start">
                                <div class="input-group input-group">
                                  <span class="input-group-text" style="width:180px;">เลขผู้เสียภาษี</span>
                                  <input type="text" class="form-control form-control-sm" name="taxno" v-model="curRecord.TaxNo">
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="col-4 text-start">
                          <!-- <div class="input-group input-group"> -->
                            <label for="code" class="mr-sm-2">ใช้ราคาขายที่ :</label>
                            <select class="form-select bg-warning" ref="UnitPriceNo" name="unitpriceno" v-model="curRecord.UnitPriceNo" title="ระบุราคาขายสำหรับคลินิกนี้ (จากราคาขายทั้งหมด 5 ราคา)">
                              <option class="bg-white" value="1">ราคาที่ 1</option>
                              <option class="bg-white" value="2">ราคาที่ 2</option>
                              <option class="bg-white" value="3">ราคาที่ 3</option>
                              <option class="bg-white" value="4">ราคาที่ 4</option>
                              <option class="bg-white" value="5">ราคาที่ 5</option>
                            </select>
                          <!-- </div> -->
                      </div>
                    </div>
                    <br>
                    <div class="row mb-2 text-start">
                        <div class="col">
                            <label for="addr1" class="mr-sm-2">ที่อยู่:</label>
                            <input type="text" class="form-control" id="addr1" placeholder="ที่อยู่" name="addr1" autocomplete="off" v-model="curRecord.Addr1">
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-6">
                            <input type="text" class="form-control" id="tambon" placeholder="ตำบล" name="tambon" autocomplete="off" v-model="curRecord.Tambon">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="amphor"  placeholder="อำเภอ" name="amphor" autocomplete="off" v-model="curRecord.Amphor">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <input type="text" class="form-control" id="province"  placeholder="จังหวัด" name="province" autocomplete="off" v-model="curRecord.Province">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="postcode"  placeholder="รหัสไปรษณีย์" name="postcode" autocomplete="off" v-model="curRecord.PostCode">
                        </div>
                    </div>
                    <br>
                    <div class="row mb-2 text-start">
                        <label for="tel1" class="mr-sm-2">Phone / Email:</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone1" placeholder="Phone no.1" name="tel1" v-model="curRecord.Tel1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone2"  placeholder="Phone no.2" name="tel2" v-model="curRecord.Tel2">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <input type="text" class="form-control" id="email1" placeholder="Enter email#1" name="email1" v-model="curRecord.Email1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="email2" placeholder="Enter email#2" name="email2" v-model="curRecord.Email2">
                        </div>
                    </div>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ref="btnCloseModal"  data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" @click="saveData()">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'Clinics1View',
  components: {

  },
  data () {
    return {
      datalists: null,
      provinceRows: [],
      curRecord: {},
      action: 'new'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.ReqClinicName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_clinic.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_clinic.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_clinic.php',
            data: { id: item.ReqClinicID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
            //   self.getData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.curRecord.ReqClinicCode = ''
      this.curRecord.ReqClinicName = ''
      this.curRecord.UnitPriceNo = 1
      this.action = 'new'
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    getData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myClinicTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    checkFieldsBeforeSave () {
      if ((this.curRecord.ReqClinicCode === '')) {
        this.$refs.ReqClinicCode.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "รหัสคลินิก/หน่วยงาน/บริษัท" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.ReqClinicName === '')) {
        this.$refs.ReqClinicName.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชื่อคลินิก/หน่วยงาน/บริษัท" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecord.UnitPriceNo <= 0)) {
        this.$refs.UnitPriceNo.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ราคาขายที่ใช้" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      return true
    },
    saveData () {
      var self = this
      if (this.checkFieldsBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        var x = $('#fmClinicReq').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // console.log(formData)
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/insert_clinic.php',
          data: { request: JSON.stringify(formData) }
        })
          .done(function (resp) {
            var elem = self.$refs.btnCloseModal
            elem.click()
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              // Refresh >> this component only
              // this.$refs.getData()
            //   self.getData()
              self.$emit('onDataChangedEvent')
              // location.reload()
              // this.$router.push('MClinics')
            })
          })
          .fail(function (resp) {
            // alert('Not Saved')
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    }
  }
}
</script>

<style>

</style>
